import { render } from "./UiButton.vue?vue&type=template&id=7d17d140&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"

import "./UiButton.vue?vue&type=style&index=0&id=7d17d140&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d17d140"]])

export default __exports__